import { DeepPartial } from 'ts-essentials';

import {
  CompanyMonitoringAlertCategoryEnum,
  WorkspaceSettingsCompanyMonitoringModel,
} from '../../../../shared/models';
import yup from '../../../../utils/yup-extended';

export const workspaceSettingsCompanyMonitoringSchema =
  (): yup.SchemaOf<WorkspaceSettingsCompanyMonitoringModel> =>
    yup.object().shape({
      alertCategories: yup
        .array()
        .of(
          yup
            .string()
            .oneOf(Object.values(CompanyMonitoringAlertCategoryEnum))
            .required()
            .defined() as yup.BaseSchema<
            CompanyMonitoringAlertCategoryEnum,
            unknown,
            CompanyMonitoringAlertCategoryEnum
          >,
        )
        .uniqueItems()
        .nullable()
        .defined(),
      //Need to re-cast otherwise there is an error
      // Type 'BaseSchema<CompanyMonitoringAlertCategoryEnum, unknown, CompanyMonitoringAlertCategoryEnum>' is not assignable to type 'BaseSchema<"financial_changes", AnyObject, "financial_changes">'
    }) as yup.SchemaOf<WorkspaceSettingsCompanyMonitoringModel>;

export const validateWorkspaceSettingsCompanyMonitoring = (
  companyMonitoringSettings: DeepPartial<WorkspaceSettingsCompanyMonitoringModel> = {},
): void => {
  workspaceSettingsCompanyMonitoringSchema().validateSync(
    companyMonitoringSettings,
    {
      abortEarly: false,
    },
  );
};
